import { api } from "./client";
import { apiRoutes } from "util/apiRoutes";

export interface UrlMetadataRecord extends Record<string, unknown> {
  id: number;
  url: string;
  canonical_url?: string | null;
  title?: string | null;
  description?: string | null;
  image_url?: string | null;
  site_name?: string | null;
  host?: string | null;
  mime_type?: string | null;
  status_code?: number | null;
  properties?: Record<string, unknown>;
}

export const urlMetadataApi = {
  resolve: async (url: string, options?: { audience?: string }): Promise<UrlMetadataRecord> => {
    const response = await api.get<UrlMetadataRecord>(apiRoutes.urls.resolve, {
      params: {
        url,
        audience: options?.audience,
      },
    });
    return response.data;
  },
};
